import { useEffect } from "react"
import axios from "axios"

import useAuthContext from "./useAuthContext"

const API_URL = process.env.REACT_APP_BASE_URL

const useSetupAxios = () => {
  const { handleLogOutUser } = useAuthContext()

  const requestInterceptor = axios.interceptors.request.use(
    (config) => {
      const conf = config
      conf.withCredentials = true // enable cookies for cross-origin requests
      const token = localStorage.getItem("nfn-access-token")
      // set token in the Authorization header if it exists
      if (token && conf.headers) conf.headers.Authorization = `Bearer ${token}`
      // remove the Authorization header if no token is present to prevent sending an invalid token
      else if (!token && conf.headers) delete conf.headers.Authorization
      return conf
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  const responseInterceptor = axios.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error.response && (error.response.status === 440 || error.response.status === 401)) {
        // this prevents a handleLogout lopp if there's a 401 error on logOut/authenticate api
        if (!localStorage.getItem('isLoggedOut')) {
          localStorage.setItem('isLoggedOut', 'true');
          handleLogOutUser();
        }
      }
      return Promise.reject(error);
    }
  )

  useEffect(() => {
    return () => {
      axios.interceptors.request.eject(requestInterceptor)
      axios.interceptors.response.eject(responseInterceptor)
    }
  }, [requestInterceptor, responseInterceptor])

  return null // This hook does not return anything
}

export default useSetupAxios
